module.exports = __webpack_public_path__ + "img/search3_g.6f4a791b.svg";